export default __webpack_public_path__ + "static/media/breaker1.ab533a8f.png";